import { connect } from 'react-redux'
import Header from 'pages/account/Header'
import { isRoles } from 'redux/actions'

const mapStateToProps = (state) => ({
  userIs: (props) => isRoles(state, props)
})

export default connect(mapStateToProps, null)(Header)
